import { Box, Group, LoadingOverlay, Paper, Stack, Text } from '@mantine/core'
import { type FC, type ReactNode } from 'react'

export interface ProfileCardProps {
  buttons?: ReactNode
  children: ReactNode
  loading?: boolean
  title: string
}

export const ProfileCard: FC<ProfileCardProps> = ({ buttons, children, loading = false, title }) => (
  <Paper
    display='flex'
    p='lg'
    pos='relative'
  >
    <Stack
      justify='space-between'
      pos='relative'
      spacing='lg'
      w='100%'
    >
      <LoadingOverlay visible={loading} />
      <Text
        color='navy'
        weight='bold'
      >
        {title}
      </Text>
      <Box h='100%'>{children}</Box>
      {buttons && (
        <Group
          mt='xl'
          position='right'
        >
          {buttons}
        </Group>
      )}
    </Stack>
  </Paper>
)
